<template>
  <div>
    <div>
			<span class="xbed-sub-title">修改远期房态</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>管理员权限</BreadcrumbItem>
				<BreadcrumbItem>修改远期房态</BreadcrumbItem>
			</Breadcrumb>
		</div>
    <br>
    <div style="min-height: 500px">
      <Form @submit.native.prevent="preventSubmit" :rules="editRoomStatusRules" ref="editRoomStatusForm">
        <FormItem label="房间ID：" prop="query.roomId" :label-width="95">
          <Input type="text" v-model="query.roomId" style="width:500px"></Input>
        </FormItem>
        <FormItem label="订单号：" prop="query.orderNo" :label-width="95">
          <Input type="text" v-model="query.orderNo" style="width:500px"></Input>
        </FormItem>
        <FormItem label="清洁单号：" prop="query.cleanOrderNo" :label-width="95">
          <Input type="text" v-model="query.cleanOrderNo" style="width:500px"></Input>
        </FormItem>
        <FormItem prop='creatTime' label='修改日期：' :label-width='95'>
          <DatePicker type='daterange' v-model="creatTime" placeholder="选择日期" :clearable="false" style="width: 500px"></DatePicker>
        </FormItem>
        <FormItem label='目标房态：' :label-width='95' prop="query.roomStatus">
          <Select v-model="query.roomStatus" placeholder="请选择" style="width:500px">
            <Option :value="1">可预订</Option>
            <Option :value="2">已预订</Option>
            <Option :value="3">维修</Option>
            <Option :value="4">停用</Option>
          </Select>
        </FormItem>
        <FormItem :label-width='95'>
          <Button type="primary" style="width:500px" @click="sendBtn" :loading='sendLoading'>发送</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import Moment from "moment"
import Utils from "@/utils";
import API from "@/api";
export default {
  async created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
  data () {
    const validateList = {
      roomId: ( rule, value, callback ) => {
				if ( !this.query.roomId) {
					callback( new Error( '房间ID不能为空' ) )
				} else {
					callback();
				}
			},
      roomStatus: ( rule, value, callback ) => {
				if ( !this.query.roomStatus ) {
					callback( new Error( '目标房态不能为空' ) )
				} else {
					callback();
				}
			},
    }
    return {
      creatTime:[
        Moment().subtract( 0, 'day' ).format( 'YYYY-MM-DD' ),
				Moment().format( 'YYYY-MM-DD' )
      ],
      sendLoading:false,
      query:{
        roomId:'',
        roomStatus:0,
      },
      editRoomStatusRules:{
        roomId: [
					{required: true, validator: validateList.roomId, trigger: 'blur'}
				],
        roomStatus: [
					{required: true, validator: validateList.roomStatus, trigger: 'change'}
				],
      }
    }
  },
  mounted() {
		this.$Notice.config( {
			top: 200
		});
	},
  methods: {
    async sendBtn(){
      let validResult = false
      this.$refs.editRoomStatusForm.validate(valid =>{
         validResult = valid
      })
      if ( !validResult ) {
				return;
      }
      let roomId = this.query.roomId.replace(/\s*/g,"").split(",")
      for(let i=0;i < roomId.length;i++){
        if (roomId[i].length > 9) {
          this.$Notice.error({
            title: "房间ID长度不能大于9"
          });
          return
        }
      }
      let params = {
        url:'/v1/api/oms/calendar/updateStat',
        operator:this.username,
        stat:this.query.roomStatus,
        beginDate:Moment(this.creatTime[0]).format('YYYY-MM-DD'),
        endDate:Moment(this.creatTime[1]).format('YYYY-MM-DD'),
        roomIds:this.query.roomId
      }
      this.sendLoading = true
      let resp = (await API.omsAPI[this.env].system.postAlendarUpdateStat(params, this.token)).data
      this.sendLoading = false
      if (resp.retCode) {
        this.$Notice.error({
          title: "修改失败",
          desc: resp.msg
        });
        return
      }
      this.$Notice.success({
        title: "修改成功",
        desc: resp.msg
      });
      this.query = {
        roomId:'',
        roomStatus:0
      }
      this.creatTime = [Moment().subtract( 0, 'day' ).format( 'YYYY-MM-DD' ),Moment().format( 'YYYY-MM-DD' )]
    },
    preventSubmit(){
      return false
    }
  },
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/system/editRoomStatus.vue